import React, { useContext } from "react";
import { api } from "/@src/network/auth";
import { findNextRecommendationPlan } from "/@src/constants/plansAndFeatures";
import { openModal } from "/@src/redux/modal/actions";
import Plans from "./plans/Plans";
import { useDispatch } from "react-redux";

export const BillingContext = React.createContext({});

export const useBillingContext = () => useContext(BillingContext);

const BillingProvider = ({ children }) => {
  const changePlan = () => {
    return api.post("/stripe/customer-portal-session", {}).then((response) => {
      const { url } = response.data;
      window.open(url, "_blank");
    });
  };

  const dispatch = useDispatch();

  const upgradePlanModal = (standardPlans, userPlan, usages, f) => {
    const upgradeTo = findNextRecommendationPlan(
      standardPlans,
      userPlan,
      usages,
      f
    );
    dispatch(
      openModal({
        id: "upgrade-plans",
        size: "xl",
        title: `Upgrade`,
        children: (
          <div>
            <h6>Upgrade plan to use this feature.</h6>
            <Plans currentPlan={userPlan?.name} upgradePlanTo={upgradeTo} />
          </div>
        ),
      })
    );
  };

  return (
    <BillingContext.Provider value={{ changePlan, upgradePlanModal }}>
      {children}
    </BillingContext.Provider>
  );
};

export default BillingProvider;
